import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const dataSlice = createSlice({
  name: "create-question",
  initialState: initialState,
  reducers: {
    initCreateQuestion: () => {
      return { ...initialState };
    },
    startCreateQuestion: (state) => {
      state.loading = true;
    },
    successCreateQuestion: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorCreateQuestion: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initCreateQuestion,
  startCreateQuestion,
  successCreateQuestion,
  errorCreateQuestion,
} = dataSlice.actions;

export default dataSlice.reducer;
